import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { UIRouterModule, Ng2StateDeclaration } from '@uirouter/angular';
import { NgSelectModule } from '@ng-select/ng-select';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { AppComponent } from './app.component';

import * as $ from 'jquery';
import { DateTimeUtilityService } from './core/services/date-time-utility.service';
import { appInitConfig, AppInitService } from './core/services/app-init.service';
import { AppErrorHandler } from './core/services/app-error-handler.service';

// Migrated Module Components
import { FooterModule } from './features/footer/footer.module';
import { HeaderModule } from './features/header/header.module';
import { MissionControlPageModule } from './pages/mission-control-page/mission-control-page.module';
import { SharedModule } from './shared/shared.module';
import { LoginPageModule } from './pages/login-page/login-page.module';
import { ForgotPasswordPageModule } from './pages/forgot-password-page/forgot-password-page.module';
import { ResetPasswordPageModule } from './pages/reset-password-page/reset-password-page.module';
import { ValidateOtpPageModule } from './pages/validate-otp-page/validate-otp-page.module';
import { ExitMeetingPageModule } from './pages/exit-meeting-page/exit-meeting-page.module';
import { CandidateConferencePageModule } from './pages/candidate-conference-page/candidate-conference-page.module';
import { TokenLoginPageModule } from './pages/token-login-page/token-login-page.module';
import { ConferencePageModule } from './pages/conference-page/conference-page.module';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    UIRouterModule.forRoot({ config: appInitConfig }),
    NgSelectModule,
    CoreModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      tapToDismiss: false,
      closeButton: true
    }),
    FooterModule,
    HeaderModule,
    MissionControlPageModule,
    SharedModule,
    LoginPageModule,
    ForgotPasswordPageModule,
    ResetPasswordPageModule,
    ValidateOtpPageModule,
    ExitMeetingPageModule,
    CandidateConferencePageModule,
    TokenLoginPageModule,
    ConferencePageModule
  ],
  providers: [
    { provide: ErrorHandler, useExisting: AppErrorHandler },
    CoreModule,
    // Registered explicitly (not just providedIn: 'root') so it resolves as a compile-time
    // NgModule provider rather than a lazily tree-shaken one: requesting a tree-shakable
    // provider for the first time from inside UIRouterModule.forRoot's synchronous `config`
    // callback hits a ViewEngine edge case where the lazy-provider slot reads back as
    // `undefined` instead of being constructed.
    AppInitService],
  entryComponents: [AppComponent],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class AppModule {
  constructor(private dateService: DateTimeUtilityService) {
  }
}
